import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CampaignDetail from './CampaignDetail';
import CampaignPublisherDetail from './CampaignPublisherDetail';
import CampaignInsight from './CampaignInsight';
import { Icons } from '@/icons';
import { AdminCampaignTypes, CampaignType, GamicType, UserType } from './types';
import { useDispatch } from 'react-redux';
import {
  deleteCampaign,
  fetchCampaignById,
  updateCampaignStatus,
} from '@/store/Campaign';
import { fetchGamicById } from '@/store/Gamic';
import { fetchUserByAdmin } from '@/store/User';
// import { updateCampaignStatus } from '@/store/Campaign';

const PreviewCampaign: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    'details' | 'publisher' | 'insight'
  >('details');

  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const campaign = (state as { campaign?: AdminCampaignTypes })?.campaign;
  const [campaignData, setCampaignData] = useState<CampaignType>();
  const [gamic, setGamic] = useState<GamicType>();
  const [user, setUser] = useState<UserType>();

  const location = useLocation();

  useEffect(() => {
    if (!campaign) navigate(-1);
  }, [campaign, navigate]);

  const data = async () => {
    if (campaign) {
      const res = await dispatch(fetchCampaignById(campaign.id));
      setCampaignData(res.payload.data[0]);
      const resG = await dispatch(fetchGamicById(campaign.gamic_id));
      setGamic(resG.payload.data[0]);
      const resU = await dispatch(fetchUserByAdmin(campaign.user_id));
      setUser(resU.payload.data[0]);
    }
  };

  useEffect(() => {
    data();
  }, []);

  if (!campaign || !campaignData || !gamic || !user) return null;

  const handleApprove = async () => {
    await dispatch(
      updateCampaignStatus({
        campaignId: campaign.id,
        status: 'approved',
      }),
    );
    data();
  };

  const handleReject = async () => {
    await dispatch(
      updateCampaignStatus({
        campaignId: campaign.id,
        status: 'rejected',
      }),
    );
    data();
  };

  const handleRemove = async () => {
    await dispatch(deleteCampaign(campaign.id));

    if (location.pathname === '/admin/campaign/preview') {
      navigate('/admin/campaigns');
    }
  };

  return (
    <div className='bg-white rounded-[24px] h-full flex flex-col'>
      {/* ───────── Tabs ───────── */}
      <div className='px-[20px]  rounded-[16px] bg-[#FFFFFF] pb-0 space-x-[32px] h-[77px]'>
        {(['details', 'publisher', 'insight'] as const).map((k) => (
          <button
            key={k}
            onClick={() => setActiveTab(k)}
            className={`flex-1 text-center h-full text-[18px] ${
              activeTab === k
                ? 'border-b-2 border-[#FF0050] text-[#FF0050]'
                : 'text-gray-500'
            }`}
          >
            {k === 'details'
              ? 'Campaign Details'
              : k === 'publisher'
                ? 'Publisher Details'
                : 'Campaign Insight'}
          </button>
        ))}
      </div>

      {/* ───────── Tab Content ───────── */}
      <div className='p-6 flex-1 overflow-y-auto scrollbar scrollbar-thumb-[#EEEEEE] scrollbar-track-transparent'>
        {activeTab === 'details' && (
          <CampaignDetail campaign={campaignData} gamic={gamic} />
        )}
        {activeTab === 'publisher' && <CampaignPublisherDetail user={user} />}
        {activeTab === 'insight' && (
          <CampaignInsight campaignData={campaignData} gamic={gamic} />
        )}
      </div>

      {/* ─── Actions ─── */}
      <div className='flex items-center justify-between pt-6 px-6 pb-6'>
        <button
          onClick={handleRemove}
          className='flex items-center px-4 py-2 border border-black rounded-[100px] text-gray-700 hover:bg-gray-50'
        >
          <Icons.Delete className='mr-2 w-4 h-4' />
          Remove
        </button>

        {campaignData.status === 'pending' && (
          <div className='flex gap-3'>
            <button
              onClick={handleReject}
              className='px-6 py-2 bg-[#FF0000] text-white rounded-[100px] hover:bg-red-600'
            >
              Rejected
            </button>
            <button
              onClick={handleApprove}
              className='px-6 py-2 bg-[#1FAA03] text-white rounded-[100px] hover:bg-green-600'
            >
              Approve
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PreviewCampaign;
